import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import CenterTreatmentRevenueReport from "../components/CenterTreatmentRevenueReport";
const TreatmentRevenueOverviewPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout >

        {/* Breadcrumb */}
        <Breadcrumb title="Centers Treatment Revenue Overview" />

        <CenterTreatmentRevenueReport />

      </MasterLayout>
    </>
  );
};

export default TreatmentRevenueOverviewPage;
